import {
  ArrowLeft,
  ArrowRight,
  Download,
  Folder,
  ForkLeft,
  InboxOutlined,
} from "@mui/icons-material";
import { Pagination } from "@mui/material";
import React, { useState, useEffect } from "react";
import { FaEye, FaFile, FaFileArchive, FaFilePdf } from "react-icons/fa";
import { ApiUrl, FileLink } from "../../config";

const AllDocument = ({ dec_uid, token ,searchDocumentQuery }) => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("");

  const fetchDocuments = async (page = 1) => {
    try {
      const response = await fetch(
        `${ApiUrl}get-Document-by-decId?declaration_id=${dec_uid}&page=${page}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const data = await response.json();
      setDocuments(data.data);
      setTotalPages(data.last_page);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocuments(currentPage);
  }, [dec_uid, token, currentPage]);

  const filteredDocuments = documents.filter((doc) => {
    return doc.nom.toLowerCase().includes(searchDocumentQuery.toLowerCase()) || 
           doc.type_document.toLowerCase().includes(searchDocumentQuery.toLowerCase());
  });
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    fetchDocuments(value);
  };

  // Handle modal visibility and set the content for preview
  const handleShowModal = (doc) => {
    const fileType = doc.type_document.toLowerCase();

    const fileUrl = `${FileLink}${doc.documents_path}`;  // Use the FileLink constant


    if (fileType === "png" || fileType === "jpg" || fileType === "jpeg") {
      setModalContent({
        type: "image",
        url: fileUrl,
      });
    } else if (doc.type_document === "pdf") {
      setModalContent({
        type: "pdf",
        url: fileUrl,
      });
    } else {
      // Handle other file types, show image icon with download link
      setModalContent({
        type: "other",
        url: fileUrl,
        isImage: false,
      });
    }
    setShowModal(true); // Show the modal
  };

  // Handle modal close
  const handleCloseModal = () => {
    setShowModal(false);
    setModalContent(""); // Clear the modal content when closing
  };

  // Handle download (for PDF or images)
  const handleDownload = (doc) => {
    const link = document.createElement("a");
    link.href = `${FileLink}${doc.documents_path}`;
    link.download = doc.nom;
    link.click();
  };

  if (loading) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center my-4">
        <div
          className="spinner-border text-primary"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3 text-muted">Chargement en cours...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center my-4">
        <div className="alert alert-danger d-inline-block" role="alert">
          <strong>Erreur :</strong> {error}
        </div>
      </div>
    );
  }

  return (
    <div>
      <table className="table text-nowrap table-hover">
        <thead>
          <tr>
            <th scope="col">Fichier</th>
            <th scope="col">Par</th>
            <th scope="col">Type</th>
            <th scope="col">Date</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        
        <tbody className="files-list">
          {documents.length === 0 || filteredDocuments.length===0 ? (
            <tr>
              <td colspan="100%">
                <div className="text-center p-5">
                  <div className="mt-md-3 mt-xl-0 text-muted">
                    {/* <i className="feather icon-inbox display-6"></i> */}
                    <InboxOutlined
                      style={{
                        fontSize: "50px",
                        color: "rgb(167 166 166)",
                      }}
                    />
                  </div>
                  <p
                    className="empty-title"
                    style={{
                      marginTop: "8px",
                      fontSize: "16px",
                      color: "rgb(112 110 110)",
                    }}
                  >
                    Aucun résultat trouvé
                  </p>
                </div>
              </td>
            </tr>
          ) : (
            filteredDocuments.map( (doc, index) => (
              <tr key={index}>
                <th scope="row">
                  <div className="d-flex align-items-center">
                    <div className="me-2">
                      <span className="avatar avatar-xs">
                        <img
                          src="https://spruko.com/demo/ynex/dist/assets/images/media/file-manager/1.png"
                          alt="File Icon"
                        />
                      </span>
                    </div>
                    <div>
                      {doc.nom?.length > 50
                        ? `${doc.nom.substring(0, 20)}...`
                        : doc.nom}
                    </div>
                  </div>
                </th>
                <td>
                  {doc.user?.employe
                    ? `${doc.user.employe.nom} ${doc.user.employe.prenom}`
                    : "N/A"}
                </td>
                <td>{doc?.type_document || "-"}</td>
                <td>{new Date(doc.created_at).toLocaleDateString()}</td>
                <td>
                  <div className="hstack gap-2 fs-15">
                    <div
                      className="custom-btn fw-bold custom-btn-warning-outline me-2"
                      onClick={() => handleShowModal(doc)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaEye style={{ fontSize: "18px" }} />
                    </div>
                    <div
                      className="custom-btn fw-bold custom-btn-warning-outline"
                      onClick={() => handleDownload(doc)}
                      style={{ cursor: "pointer" }}
                    >
                      <Download style={{ fontSize: "18px" }} />
                    </div>
                  </div>{" "}
                </td>
              </tr>
            ))
          )}
        </tbody>
        <tfoot>
          {documents && documents.length > 0 ? (
            <tr>
              <td colSpan="9">
                <div className="d-flex justify-content-between align-items-center p-1">
                  <div></div>
                  <div>
                    <Pagination
                      count={totalPages}
                      page={currentPage}
                      onChange={handlePageChange}
                      color="primary"
                      shape="rounded"
                      sx={{
                        "& .MuiPaginationItem-root": {
                          borderRadius: "50px",
                          backgroundColor: "#f1f1f1",
                          "&.Mui-selected": {
                            backgroundColor: "rgb(255, 77, 7)",
                            color: "white",
                          },
                          "&:hover": {
                            backgroundColor: "#e0e0e0",
                          },
                        },
                        marginTop: "20px",
                      }}
                    />
                  </div>
                </div>
              </td>
            </tr>
          ) : (
            <tr>
              <td colSpan="9"></td>
            </tr>
          )}
        </tfoot>
      </table>



      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
          role="dialog"
          aria-labelledby="documentModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="documentModalLabel">
                  Document Preview
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                {modalContent.type === "image" ? (
                  <img
                    src={modalContent.url}
                    alt="Document"
                    className="img-fluid"
                    style={{ maxHeight: "80vh" }}
                  />
                ) : modalContent.type === "pdf" ? (
                  <div className="d-flex flex-column align-items-center">
                    <FaFilePdf
                      style={{ fontSize: "100px", color: "#E60000" }}
                    />
                    <a
                      href={modalContent.url}
                      download
                      className="custom-btn btn-black mt-2"
                    >
                      Download PDF
                    </a>
                  </div>
                ) : (
                  <div  className="d-flex flex-column align-items-center">
                    

                    <FaFile style={{ fontSize: "80px", color: "#6c757d" }} />
                    <a
                      href={modalContent.url}
                      download
                      className="custom-btn btn-black mt-2"
                    >
                      Download 
                    </a>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllDocument;
